import { useFittedText } from "../hooks/useFittedText";

const MessageBox = ({ kind, settings }) => {
  const fontSize = Math.max(kind === "header" ? 14 : 12, settings.fontSize * 0.8);
  const { containerRef, textRef } = useFittedText(settings.text, fontSize);
  return (
    <div
      ref={containerRef}
      className={`h-full w-full min-h-0 min-w-0 flex items-center justify-center overflow-hidden ${kind === "header" ? "sm:max-w-[90%]" : "sm:max-w-[80%]"}`}
      style={{
        backgroundColor: settings.bgColor,
        color: settings.textColor,
        borderRadius: `${settings.borderRadius}px`,
        padding: `min(${settings.padding}px, 2vh) min(${settings.padding}px, 5vw)`,
        textAlign: "center",
      }}
      data-testid={`${kind}-box`}
    >
      <p
        ref={textRef}
        className="w-full min-w-0 m-0"
        style={{
          fontSize: `${fontSize}px`, lineHeight: 1.3,
          fontWeight: kind === "header" ? 600 : 400,
          whiteSpace: "pre-wrap", overflowWrap: "anywhere",
        }}
        data-testid={`${kind}-text`}
      >
        {settings.text}
      </p>
    </div>
  );
};

// This slot stays mounted and occupies 15%, even when its message is disabled.
export const TranslationMessageBand = ({ kind, settings }) => (
  <div
    className="h-full min-h-0 min-w-0 flex items-center justify-center overflow-hidden px-4 sm:px-8 py-1"
    data-testid={`${kind}-container`}
    aria-hidden={!settings.enabled}
  >
    {settings.enabled && <MessageBox kind={kind} settings={settings} />}
  </div>
);